import React, {Component} from 'react'
import styled from 'styled-components'
import fire from '../database/firebase'
import MediaQuery from 'react-responsive';
import {Nav, Navbar, Image, Button, NavbarBrand, NavDropdown, Container} from 'react-bootstrap'

const Styles = styled.div `

    // - - FULL PAGE - - //

.fullPage {
    height: 100%;
    position: relative;
}

    // - - NAVBAR - - //

//  .navbarContainer {
//     width: 100%;
// }

.navbar {
    background-color: #fff;
}

.logo-image {
    width: 50px; /* Adjust the width as needed */
    height: 50px; /* Adjust the height as needed */
    margin-right: 0.5%; /* Adjust the margin as needed */
}

.navbar-brand {
    // background-color: white;
    font-size: 25.5px;
    color: black;
    font-family: dm sans;
    // padding-left: 1%;
}

.navbarLogo:hover {
    color: #FF962D;
}
    
    /* Style for the navigation links */
.navbar-nav {
    margin-left: auto; /* Push links to the right */
    margin-right: 25%;
}

.navLink {
    margin-right: 50%;
    font-size: 18.5px;
    margin-left: 50%;
}
    
    /* Style for individual navigation link items */
.nav-link {
    color: #000;
    // font-weight: bold;
    font-family: dm sans;
}
    
    /* Hover effect for navigation links (optional) */
.nav-link:hover {
    text-decoration: none;
    color: #FF962D; 
}

    /* Style for the collapsed (mobile) Navbar button (optional) */
.navbar-toggler-icon {
    color: white;
}

    /* Style for the expanded (mobile) Navbar background (optional) */
.navbar-expand-lg .navbar-collapse {
    background-color: #fff;
}
    
    
.signUpBtnContainer {
    margin-left: 2.5%;
}

.signUpBtn {
    width: 160px;
    background-color: #FFB76F;
    color: white;
    border: 2px solid #FFB76F;
    font-family: dm sans;
    color: black;
    font-weight: bold;
}
    
.signUpBtn:focus {
    background-color: #FFB76F;
    color: black;
    border: 2px solid #FFB76F;
}

    // - - ABOUT - - //

.about {
    // height: 100%;
    // position: relative;
}


    // - - HEADER - - //

.header {
    text-align: center;
    font-family: sora;
}

.header h1 {
    margin-top: 
}

.header h2 {
    margin-top: 2.5%;
    margin-left: 5%;
    margin-right: 5%;
}

    // - - FOOTER - - //

.footer {
    text-align: right;
}

.footer h5 {
    // position: absolute;
    text-align: right;
    // bottom: 0;
    padding-top: 5.5%;
    margin-right: 2.5%;
}

.footer img {
    text-align: right;
    width: 12.5%;
    margin-right: 2.5%;
    cursor: pointer;
}   

`

export default class About extends Component {
    constructor(props) {
        super(props)
        this.state = {

        }
    }

    buyMeACoffeBtnClicked = () => {
        window.location.href = ""
        window.open("https://www.buymeacoffee.com/granolanotes", "_blank");
    }

    render () {

        const computerMediaQuery = `(min-width: 1025px)`
        const tabletMediaQuery = `(min-width: 769px) and (max-width: 1024px)`; 
        const phabletMediaQuery = `(min-width: 415px) and (max-width: 768px)`
        // const standardPhoneQuery = `(min-width: 376px) and (max-width: 414px)`
        const smallPhoneQuery = `(min-width: 320px) and (max-width: 414px)`

        return (
            <Styles>
                <MediaQuery query={computerMediaQuery}>
                    <div className='fullPage'>
                        <Navbar className='navbar' expand="lg">
                            <Image src="/assets/granolaNoats.png" alt="Your Logo" className="logo-image" />
                            <Navbar.Brand className='navbarLogo' href="/"><strong>granola notes</strong></Navbar.Brand>
                            <Navbar.Toggle aria-controls="basic-navbar-nav" />
                            <Navbar.Collapse id="basic-navbar-nav">
                            <Nav className="ml-auto">
                                <Nav.Link className='navLink' href="/"><strong>notes</strong></Nav.Link>
                                <Nav.Link className='navLink' href="/about"><strong>about</strong></Nav.Link>
                                {/* <Nav.Link className='navLink' href=""><strong>Login</strong></Nav.Link> 
                                <Nav.Item className='signUpBtnContainer'>
                                    <Button href='/register' className='signUpBtn'>Sign Up</Button>
                                </Nav.Item>  */}
                            </Nav>
                            </Navbar.Collapse>
                        </Navbar>
                        
                        <div className='about'>
                            <div className='header'>
                                <h1 style={{textAlign: "center", fontFamily: "sora", fontWeight: "bold", marginTop: "4%", marginBottom: "1.5%"}}>about granola notes</h1>
                                <h2>the goal of granola notes is to create a safe online space for people who strongly feel they suffer from npd (or strong narcissistic tendencies) to cope with and learn more about narcissism via various online resources. </h2>
                            </div>
                            <div className='header'>
                                <h1 style={{textAlign: "center", fontFamily: "sora", fontWeight: "bold", marginTop: "5%", marginBottom: "1.5%"}}>about the person behind granola notes</h1>
                                <h2>I am 20-something y/o that exhibits several behaviors that strongly align with npd, though I am undiagnosed. After having joined various online communities and done quite a bit of digging online, I decided to compile all the helpful (imo) resources I've found along the way! </h2>
                            </div>
                            <div className='footer'>
                                <h5>If you find the content helpful and would like to support - feel free to drop a donation :) </h5>
                                <img onClick={this.buyMeACoffeBtnClicked} src='/assets/bmc-button.png'/>
                            </div>
                        </div>
                    </div>
                </MediaQuery>
            </Styles>
        )
    }
}